import React from 'react';
import { useEffect } from 'react';
import $ from 'jquery';
import { Link, NavLink } from 'react-router-dom';
const HomeNavbar = () => {
  const JavascriptVoid = (event) => {
    event.preventDefault();
  };
  useEffect(() => {
    $(window).scroll(function () {
      var sticky = $('.header-b'),
        scroll = $(window).scrollTop();

      if (scroll >= 40) {
        sticky.addClass('nav-header-sticky');
      }
      else {
        sticky.removeClass('nav-header-sticky');
      }
    });
  }, [])

  return (
    <div>
      <>

        {/*End Sticky Icon*/}
        {/* Start Preloader Area */}
        <div className="preloader">
          <div className="spinner" />
        </div>
        {/* End Preloader Area */}
        {/* Start Lg Screen Navbar Area */}
        <header className="new-header-homepage">
          <div className="topbar text-white">
            <div className="container">
              <div className="row">
                <div className="col-lg-5 left_top_h_col">
                  <div className="top-he-left">
                    <div className="social-md-icb">
                      <ul className="social-icons d-flex m-0">
                        <li className="list-unstyled px-2">
                          <a
                            href="https://www.facebook.com/AlobhaTechnology/"
                            className="text-dark"
                            target="_blank"
                          >
                            <i className="fa fa-facebook" />
                          </a>
                        </li>
                        <li className="list-unstyled px-2">
                          <a
                            href="https://twitter.com/AlobhaTech"
                            className="text-dark"
                            target="_blank"
                          >
                            <i className="fa fa-twitter" />
                          </a>
                        </li>
                        <li className="list-unstyled px-2">
                          <a
                            href="https://www.linkedin.com/company/alobha-technologies"
                            className="text-dark"
                            target="_blank"
                          >
                            <i className="fa fa-linkedin" />
                          </a>
                        </li>
                        <li className="list-unstyled px-2">
                          <a
                            href="https://www.instagram.com/alobha_technologies/"
                            className="text-dark"
                            target="_blank"
                          >
                            <i className="fa fa-instagram" />
                          </a>
                        </li>
                        <li className="list-unstyled px-2">
                          <a
                            href="https://www.youtube.com/@alobhatechnologies1722"
                            className="text-dark"
                            target="_blank"
                          >
                            <i className="fa fa-youtube" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-7 col-12 ml-auto right_top_h_col">
                  <div className="top-contact d-flex">
                    {/* <div className="single-contact px-2 d-none">
                      <i className="fa fa-phone px-1" />
                      <Link to="tel:+919999999999">Phone: +91 9999999999</Link>
                    </div> */}
                    <div className="single-contact px-2">
                      <i className="fa fa-envelope-open px-1" />
                      <Link to="mailto:info@alobhatechnologies.com">
                        Email: info@alobhatechnologies.com
                      </Link>
                    </div>
                    <div className="single-contact px-2 become-partner-btn-head">
                      <i className="fa fa-user px-1" />
                      <Link to="/become-a-partner" className='become-a-partner'>Become A Partner</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* -----------------------------top bar end ------------------------------- */}
          <div className="nav-sticky header-b">
            <nav
              id="navbar"
              className="navbar navbar-dark navbar-expand-sm custom-navbr-css p-0"
            >
              <div className="container">
                <div className="logo-dv">
                  <Link className="navbar-brand" to="/">
                    <img src="assets/img/logo-critsmas.png" alt="logo" />
                  </Link>
                </div>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbar-list-11"
                  aria-controls="navbarNav"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon" />
                </button>
                <div className="collapse navbar-collapse" id="navbar-list-11">
                  <ul className="navbar-nav ml-auto">
                    <li className="nav-item" >
                      <NavLink className={({ isActive }) => (isActive ? "nav-link active" : 'nav-link')} to="/" >
                        Home
                      </NavLink>
                    </li>
                    <li className="nav-item" >
                      <NavLink className={({ isActive }) => (isActive ? "nav-link active" : 'nav-link')} to="/about-us" >
                        About Us
                      </NavLink>
                    </li>
                    <li className="nav-item mob-service-tab" >
                      <NavLink className={({ isActive }) => (isActive ? "nav-link active" : 'nav-link')} to="/services" >
                        Services
                      </NavLink>
                    </li>
                    <li className="nav-item dropdown megamenu-li dis1 position-static" >
                      <NavLink className={({ isActive }) => (isActive ? "nav-link active" : 'nav-link')} to="/services" >
                        Services{" "}
                      </NavLink>
                      <span
                        className="dropdown-toggle"
                        role="button"
                        data-toggle="dropdown"
                        aria-expanded="false"
                      ></span>
                      <div className="dropdown-menu megamenu">
                        <div className="row">
                          <div className="col-12 d-flex justify-content-center p-3">
                            <div className="w20">
                              <h5 className="text-capitalize font-weight-bold">
                                Application Development, Assurance &amp; Support
                              </h5>
                              <div className="border20">
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Android App
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  IOS App
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Hybrid Apps
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Web Application
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Game
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Software
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Big Data
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Artificial Intelligence
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Blockchain
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Internet of Things
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Robotic Process Automation
                                </Link>
                              </div>
                            </div>
                            <div className="w20">
                              <h5 className="text-capitalize font-weight-bold">
                                Enterprise Solutions
                              </h5>
                              <div className="border20">
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Enterprise Resource Planning
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Customer Relationship Management
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Human Capital Management
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Supply Chain Management
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Business Intelligence
                                </Link>
                              </div>
                            </div>
                            <div className="w20">
                              <h5 className="text-capitalize font-weight-bold">
                                Interactive Technology
                              </h5>
                              <div className="border20">
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Augmented Reality
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Virtual Reality
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Gesture Recognition
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Interactive Solutions
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Holographic Solutions
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  3D Projection
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Gamification
                                </Link>
                              </div>
                            </div>
                            <div className="w20">
                              <h5 className="text-capitalize font-weight-bold">
                                Cloud Services
                              </h5>
                              <div className="border20">
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Cloud Development and Migration
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Cloud Managed Services
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Cloud Analytics
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Infrastructure as a Service
                                </Link>
                              </div>
                            </div>
                            <div className="w20">
                              <h5 className="text-capitalize font-weight-bold">
                                Technology Consulting
                              </h5>
                              <div className="border20">
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Software Consulting
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Cloud Consulting
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  IT Infrastructure Consulting
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Security Consulting
                                </Link>
                                <Link
                                  className="dropdown-item text-capitalize"
                                  to="/" onClick={JavascriptVoid}
                                >
                                  Digital Strategy Consulting
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="nav-item" >
                      <NavLink className={({ isActive }) => (isActive ? "nav-link active" : 'nav-link')} to="/portfolio" >
                        Portfolio
                      </NavLink>
                    </li>
                    <li className="nav-item" >
                      <NavLink className={({ isActive }) => (isActive ? "nav-link active" : 'nav-link')} to="/career" >
                        Careers
                      </NavLink>
                    </li>
                    <li className="nav-item" >
                      <NavLink className={({ isActive }) => (isActive ? "nav-link" : 'nav-link')} to="https://blog.alobhatechnologies.com/" target='_blank'>
                        Blog
                      </NavLink>
                    </li>
                    <li className="nav-item" >
                      <NavLink className={({ isActive }) => (isActive ? "nav-link active" : 'nav-link')} to="/contact-us" >
                        Contact Us
                      </NavLink>
                    </li>
                    <li className="nav-item nav-it-bg-col" >
                      <Link className="nav-link" to="/get-a-quote">
                        Get a Quote
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </header>
      </>

    </div>
  )
}

export default HomeNavbar